import FetchService from "./Shared/FetchService";
export default class SEOService {
    static loadSEOInfo() {
        return FetchService.getSingleResponse("/aviso/institution/getSEOInfo");
    }
}
